// src/components/admin/TotalVisitorsChart.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CountUp from 'react-countup'; // Corrected import for CountUp

const TotalVisitorsChart = ({ data }) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h4 className="text-lg font-medium">Total Visitors</h4>

      {/* Total Visitors Count */}
      <div className="mt-4">
        <p className="text-xl font-bold">Total Unique Visitors</p>
        <p>
          <CountUp end={data?.totalVisitors || 0} separator="," />
        </p>
      </div>

      {/* Line Chart for Daily Visitors */}
      <div className="mt-6">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data?.dailyVisitors || []}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="visitors" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TotalVisitorsChart;
